// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eCp4UyECBrtMCb {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.XZ6DJA2wGCVhuU {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.laINI9zNKMzBAW {
  padding: var(--ds-space-400, 32px) 140px var(--ds-space-500, 40px) 140px;
  text-align: center;
}
.jja5TpRoMH7PPi {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.vvTfuZKVQs6vrG {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.vvTfuZKVQs6vrG:hover,
.vvTfuZKVQs6vrG:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaWelcomeModal = `eCp4UyECBrtMCb`;
export var headingImage = `XZ6DJA2wGCVhuU`;
export var contentContainer = `laINI9zNKMzBAW`;
export var ctasContainer = `jja5TpRoMH7PPi`;
export var closeButton = `vvTfuZKVQs6vrG`;
export default ___CSS_LOADER_EXPORT___;
